"use strict";
import Api from "../../api/api";
const TrainingEnvironmentVideo = React.createClass({
  propTypes: {
    showVideoCallback: React.PropTypes.func.isRequired,
    videoUrl: React.PropTypes.string.isRequired,
    accountId: React.PropTypes.number.isRequired
  },
  close() {
    Api.TrainingEnvironment.watchedVideo(this.props.accountId);
    this.props.showVideoCallback(false);
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "training-modal" }, /* @__PURE__ */ React.createElement("div", { className: "training-modal__background", onClick: this.close }), /* @__PURE__ */ React.createElement("div", { className: "training-modal__content" }, /* @__PURE__ */ React.createElement("div", { className: "training-modal__card" }, /* @__PURE__ */ React.createElement("div", { className: "training-modal__header" }, /* @__PURE__ */ React.createElement("div", { className: "training-modal__title" }, "Video Guide"), /* @__PURE__ */ React.createElement("i", { className: "training-modal__close fi-x", onClick: this.close })), /* @__PURE__ */ React.createElement("div", { className: "training-modal__body" }, /* @__PURE__ */ React.createElement(
      "iframe",
      {
        className: "training-modal__video",
        width: "560",
        height: "315",
        src: this.props.videoUrl,
        frameBorder: "0",
        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      }
    )))));
  }
});
export default TrainingEnvironmentVideo;
